import styled, { keyframes, css } from "styled-components";

export const CapsuleContainer = styled.div`
    position: relative;
    top: 50%; /* Centra verticalmente */
    left: 50%; /* Centra horizontalmente */
    transform: translate(-50%, -50%); /* Ajusta el centro del elemento */
    height: 100vh;
`

export const CapsulasImg = styled.img`
    position: absolute;
    top: 50%; /* Centra verticalmente */
    left: 50%; /* Centra horizontalmente */
    transform: translate(-50%, -50%); /* Ajusta el centro del elemento */
    height: 80%;
    opacity: 0.7;
`

export const PokemonImgFondo = styled.img.attrs(({ index }) => {
    const translateValue = (() => {
    switch (index) {
        case 0:
            return "translate(-200%, 420%)";
        case 1:
            return "translate(-70%, 380%)";
        case 2:
            return "translate(90%, 400%)";
        case 3:
            return "translate(-130%, 510%)";
        case 4:
            return "translate(100%, 530%)";
        case 5:
            return "translate(-200%, 650%)";
        case 6:
            return "translate(-10%, 600%)";
        case 7:
            return "translate(-90%, 760%)";
        case 8:
            return "translate(100%, 760%)";
    }
    })();

    // Generar un valor aleatorio para el rotate
    const randomRotate = `rotate(${Math.random() * 360}deg)`;

    // Combinar translate y rotate
    return  {
        style: {
          transform: `${translateValue} ${randomRotate}`,
        },
    };
})`
    position: absolute;
    height: 6%;
    left: 50%; /* Centra horizontalmente */
`


export const PokemonImgFrente = styled.img.attrs(({ index }) => {
    const translateValue = (() => {
    switch (index) {
        case 0:
            return "translate(-130%, 390%)";
        case 1:
            return "translate(20%, 380%)";
        case 2:
            return "translate(-195%, 530%)";
        case 3:
            return "translate(-20%, 500%)";
        case 4:
            return "translate(90%, 610%)";
        case 5:
            return "translate(-85%, 640%)";
        case 6:
            return "translate(-195%, 750%)";
        case 7:
            return "translate(25%, 750%)";
    }
    })();

    // Generar un valor aleatorio para el rotate
    const randomRotate = `rotate(${Math.random() * 360}deg)`;

    // Combinar translate y rotate
    return  {
        style: {
          transform: `${translateValue} ${randomRotate}`,
        },
    };
})`
    position: absolute;
    height: 6%;
    left: 50%; /* Centra horizontalmente */
`

const breathe = keyframes`
  0% { opacity: .7;filter: brightness(1.1); }
  50% { opacity: .9; filter: brightness(.9); }
  100% { opacity: .7; filter: brightness(1.1); }
`;

export const PokemonGashaContainer = styled.div.attrs(({ translate = "0px, 0px" }) => {
    const [x, y] = translate.split(", ");
    return {
        style: { transform: `translate(${x || "0px"}, ${y || "0px"})` },
    };
})`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 38vw;
    height: 15vh;
    pointer-events: all;

`;

export const PokemonGashaBall = styled.img.attrs(props => ({
    style: { opacity: props.opacity, width: props.ball ? '45vw' : '40vw' },
}))`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${({ focus }) =>
    focus === 1 &&
    css`
        animation: ${breathe} 1s infinite ease-in-out;
    `}
`;
